import * as React from 'react';
import { Dispatch } from 'redux';
import { ParticipantTimesMap, ParticipantViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class UploadAegisubResultRequest extends BaseApiPostRequest<
  ParticipantViewModel,
  EntityNormalizers.NormalizedEntityArray<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(
    eventVideoId: string,
    participantTimes: ParticipantTimesMap,
    component: React.Component,
    dispatch: Dispatch,
  ) {
    super(participantTimes, component, dispatch);
    this.path = `/event-videos/${eventVideoId}/participant-times`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipantsArray;
  }
}
